/* eslint-disable */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function AddUserInput({
  id = '',
  pattern = '',
  label = '',
}) {
  const dispatch = useDispatch();
  const {
    values,
    validations,
  } = useSelector(store => store.adduser);
  const valid = validations[id];
  const currentVal = values[id] || '';

  function validate(value) {
    const matches = value.match(pattern) || [];
    return matches.length > 0;
  }

  function handleChange({ target }) {
    const { value = currentVal } = target;

    const isValid = validate(value || '');
    dispatch({ type: 'EDIT_ADD_USER', id, value, valid: isValid });
  }

  function invalid() {
    if (id === 'middle_name') {
      return valid === false ? 'is-invalid' : null;
    }
    return !valid ? 'is-invalid' : null;
  }

  /*
  useEffect(() => {
    handleChange({ target: { id } });
  }, []);
  */

  return (
    <div className="form-group mb-2">
      <label htmlFor={id} className="font-weight-bold form-label">
        {label}
      </label>
      <input
        type="text"
        id={id}
        name={id}
        className={`border form-control ${invalid()}`}
        value={currentVal}
        onChange={(e) => handleChange(e)}
      />
    </div>
  );
}
